<template>
    <div id="app" style="background-color:  #e9ecef;">
        <router-view />
    </div>
</template>

<script>
import { App as CapacitorApp } from '@capacitor/app';

export default {
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
    },
    methods: {
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
        }
    },
    mounted() {
        CapacitorApp.addListener('backButton', () => {
            if (this.$route.path === '/' || this.$route.path === '/login') {
                CapacitorApp.exitApp();
            } else {
                this.$router.go(-1);
            }
        });
    },
    unmounted() {
        // Cleanup: remove event listener if needed
        CapacitorApp.removeAllListeners();
    },
};
</script>
